import { Box, Button, HStack, VStack } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React, { PropsWithChildren } from 'react';

type SidebarSubmenuProps = {
  label: string;
  icon: keyof typeof IconMap;
};

function isCurrentRoute(label: string) {
  return (
    (label === 'Invest' && window.location.pathname.startsWith('/checkout')) ||
    window.location.pathname.startsWith('/properties')
  );
}

export const SidebarSubmenu: React.FC<PropsWithChildren<SidebarSubmenuProps>> = ({ icon, label, children }) => {
  const isCurrent = isCurrentRoute(label);
  const [isOpen, setIsOpen] = React.useState(isCurrent);

  return (
    <Box
      display="flex"
      alignItems={'flex-start'}
      flexDirection="column"
      as={Box}
      borderRadius={'8px'}
      justifyContent={'flex-start'}
      cursor="pointer"
      width="full">
      <HStack justifyContent={'space-between'} width="full" onClick={() => setIsOpen(!isOpen)} paddingRight={'10px'}>
        <Button
          gap={'8px'}
          borderRadius={'6px'}
          leftIcon={
            <Icon
              icon={icon}
              boxSize="16px"
              color={isCurrentRoute(label) ? 'black' : 'blackAlpha.200'}
              variant="regular"
            />
          }
          colorScheme="black"
          fontFamily={isCurrent ? FontFamily.HELVETICA_NOW_BOLD : FontFamily.HELVETICA_NOW_REGULAR}
          fontWeight="regular"
          lineHeight={'16px'}
          variant="ghost">
          {label}
        </Button>
        <Icon
          icon={isOpen ? 'chevron-down' : 'chevron-left'}
          boxSize="15px"
          variant="solid"
          color={isCurrentRoute(label) ? 'black' : 'blackAlpha.200'}
        />
      </HStack>
      {isOpen && (
        <VStack
          alignItems="flex-start"
          justifyContent="flex-start"
          overflow="hidden"
          paddingBottom="10px"
          paddingTop="10px">
          {children}
        </VStack>
      )}
    </Box>
  );
};
